import { mutatorAction } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-ids';
import publicFolderFavoriteStore from 'owa-public-folder-favorite/lib/store/publicFolderFavoriteStore';
import getPublicFolderMailboxInfoForSmtpAddress from 'owa-public-folder-favorite/lib/services/utils/getPublicFolderMailboxInfoForSmtpAddress';
import getStore from '../store/store';
import { getUserConfiguration } from 'owa-session-store';

export default function getPublicFolderMailboxInfo(folderId: string): MailboxInfo {
    if (!getStore().has(folderId)) {
        const sourceFolder = publicFolderFavoriteStore.folderTable.get(folderId);
        const publicFolderMailbox =
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (15,13): Object is possibly 'undefined'.
            // @ts-expect-error
            sourceFolder.replicaList != undefined
                ? // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                  // -> Error TS2532 (19,19): Object is possibly 'undefined'.
                  // @ts-expect-error
                  sourceFolder.replicaList[0]
                : // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                  // -> Error TS2532 (23,19): Object is possibly 'undefined'.
                  // @ts-expect-error
                  getUserConfiguration().SessionSettings.DefaultPublicFolderMailbox;

        const publicFolderMailboxInfo = getPublicFolderMailboxInfoForSmtpAddress(
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (29,13): Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
            // @ts-expect-error
            publicFolderMailbox
        );
        addToStore(folderId, publicFolderMailboxInfo);
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (37,5): Type 'MailboxInfo | undefined' is not assignable to type 'MailboxInfo'.
    // @ts-expect-error
    return getStore().get(folderId);
}

const addToStore = mutatorAction(
    'addPublicFolderMailboxInfoToStore',
    (folderId: string, publicFolderMailboxInfo: MailboxInfo) => {
        getStore().set(folderId, publicFolderMailboxInfo);
    }
);
